import {
  type DispatcherEvent,
  generateNativeMessageSender
} from '@carvana/merch-native';
import { isNonProd } from '~/constants/environment';
import { logError } from '~/utilities/loggers';
import { type SearchDispatcherEvent, source } from './constants';

export default generateNativeMessageSender<
  DispatcherEvent | SearchDispatcherEvent
>({
  logError,
  source,
  verboseLogs: isNonProd
});
